import React from 'react';
import {useState} from 'react';
import styled from 'styled-components';

import AccordionPanel from '../../components/accordionPanel';
import {pxToEm} from '../../components/globalStyles';
import WrapperAppUl from '../../components/wrapperAppUl';

//#region Styled Components

const StyledWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`;

const StyledAccordionPanel = styled(AccordionPanel)`
  width: 100%;

  :not(:last-child) {
    margin-bottom: ${pxToEm(18)}em;
  }
`;

const StyledAccordionParagraph = styled.p`
  font-size: ${pxToEm(20)}em;
  margin: 0 0 1em;
`;

//#endregion

enum AccordionHeadline {
  BitmovinCollectors = 'Bitmovin Collectors',
  OtherCollectors = 'Other Collectors',
  AnalyticsAsBitmovinPlayerModule = 'Analytics as Bitmovin Player Module',
  DataConnectors = 'Data Connectors',
  UserSessionTracking = 'User Session Tracking',
  CustomDataInput = 'Custom Data Input',
  UnlimitedFiltersAndBreakdowns = 'Unlimited Filters and Breakdowns'
}

interface Props {
  className?: string;
}

const CloudAnalyticsAccordions: React.FunctionComponent<Props> = props => {
  const [expandedHeadline, setExpandedHeadline] = useState(AccordionHeadline.BitmovinCollectors);

  return (
    <StyledWrapperDiv className={props.className}>
      <StyledAccordionPanel
        headline={AccordionHeadline.BitmovinCollectors}
        expanded={expandedHeadline === AccordionHeadline.BitmovinCollectors}
        onExpand={() => setExpandedHeadline(AccordionHeadline.BitmovinCollectors)}>
        <WrapperAppUl>
          <li>Bitmovin Web, SmartTVs and Games Consoles</li>
          <li>Bitmovin iOS</li>
          <li>Bitmovin Android</li>
          <li>Bitmovin Roku</li>
        </WrapperAppUl>
      </StyledAccordionPanel>

      <StyledAccordionPanel
        headline={AccordionHeadline.OtherCollectors}
        expanded={expandedHeadline === AccordionHeadline.OtherCollectors}
        onExpand={() => setExpandedHeadline(AccordionHeadline.OtherCollectors)}>
        <WrapperAppUl>
          <li>Open Source: video.js, hls.js, Chromecast V3 (Shaka Player), Shaka, dash.js</li>
          <li>Native: ExoPlayer, AVFoundation, Roku</li>
        </WrapperAppUl>
      </StyledAccordionPanel>

      <StyledAccordionPanel
        headline={AccordionHeadline.AnalyticsAsBitmovinPlayerModule}
        expanded={expandedHeadline === AccordionHeadline.AnalyticsAsBitmovinPlayerModule}
        onExpand={() => setExpandedHeadline(AccordionHeadline.AnalyticsAsBitmovinPlayerModule)}>
        <WrapperAppUl>
          <li>Analytics is bundled together with Bitmovin Player</li>
          <li>As player module Analytics is easily activated</li>
        </WrapperAppUl>
      </StyledAccordionPanel>

      <StyledAccordionPanel
        headline={AccordionHeadline.DataConnectors}
        expanded={expandedHeadline === AccordionHeadline.DataConnectors}
        onExpand={() => setExpandedHeadline(AccordionHeadline.DataConnectors)}>
        <StyledAccordionParagraph>
          Use existing connectors to integrate Bitmovin Analytics data into 3rd party Data visualizations tools such as:
        </StyledAccordionParagraph>
        <WrapperAppUl>
          <li>Looker Studio</li>
          <li>Grafana</li>
          <li>Tableau</li>
        </WrapperAppUl>
        <StyledAccordionParagraph>
          Use Bitmovin's Analyics APIs to query data from your applications, in real-time. Or use full data exports to
          send data to your central data repositories
        </StyledAccordionParagraph>
      </StyledAccordionPanel>

      <StyledAccordionPanel
        headline={AccordionHeadline.UserSessionTracking}
        expanded={expandedHeadline === AccordionHeadline.UserSessionTracking}
        onExpand={() => setExpandedHeadline(AccordionHeadline.UserSessionTracking)}>
        <WrapperAppUl>
          <li>Track every user down to the event level to see where problems originate</li>
          <li>Empower your support team for fast problem solving</li>
        </WrapperAppUl>
      </StyledAccordionPanel>

      <StyledAccordionPanel
        headline={AccordionHeadline.CustomDataInput}
        expanded={expandedHeadline === AccordionHeadline.CustomDataInput}
        onExpand={() => setExpandedHeadline(AccordionHeadline.CustomDataInput)}>
        <WrapperAppUl>
          <li>Custom data fields available to send additional data</li>
          <li>Can be used as filters and breakdowns</li>
        </WrapperAppUl>
      </StyledAccordionPanel>

      <StyledAccordionPanel
        headline={AccordionHeadline.UnlimitedFiltersAndBreakdowns}
        expanded={expandedHeadline === AccordionHeadline.UnlimitedFiltersAndBreakdowns}
        onExpand={() => setExpandedHeadline(AccordionHeadline.UnlimitedFiltersAndBreakdowns)}>
        <WrapperAppUl>
          <li>We offer unlimited filters and breakdowns (to compare categories) for all metrics in the dashboard</li>
        </WrapperAppUl>
      </StyledAccordionPanel>
    </StyledWrapperDiv>
  );
};

export default CloudAnalyticsAccordions;
